// getSmsToken：自定义函数，用户返回smsToken

<template>
  <div class="verify-code">
    <el-button
      class="verify-code-button"
      :class="{ incount: countDown }"
      :disabled="countDown"
      :style="`height: ${btnHeight}px`"
      size="medium"
    >
      {{ countDown ? count + 's' : '获取验证码' }}
    </el-button>

    <el-dialog
      title="图形验证码"
      :visible.sync="dialogVisible"
      append-to-body
      width="40rem"
      :center="true"
      class="dialog"
      :before-close="clearDialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <el-form
          ref="dialogForm"
          class="form"
          :rules="dialogRules"
          :model="dialogForm"
        >
          <el-form-item prop="imgCode" :error="imgCodeError">
            <div class="flex">
              <el-input
                v-model.trim="dialogForm.imgCode"
                placeholder="请输入图形码"
                size="medium"
                @keyup.enter.native="handleCertain"
                @keydown.enter.native.prevent="() => {}"
              />
              <graphic-image-button
                v-if="dialogVisible"
                ref="graphicImageButton"
                @getCaptchaToken="value => (dialogForm.captchaToken = value)"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer">
        <el-button size="medium" @click="clearDialog">
          取 消
        </el-button>
        <el-button
          type="primary"
          :loading="buttonLoading"
          size="medium"
          @click="handleCertain"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getVerifyCodeApi } from '@/api/system'
import GraphicImageButton from './GraphicImageButton'

export default {
  name: 'CountDownButton',
  components: {
    GraphicImageButton
  },
  props: {
    // 倒数数值
    maxCount: {
      type: Number,
      default: 60
    },
    // 手机号码
    mobile: {
      type: String,
      default: ''
    },
    // 验证码标识code
    templateCode: {
      type: String,
      default: ''
    },
    // 按钮高度
    btnHeight: {
      type: [String, Number],
      default: 40
    }
  },
  data() {
    return {
      // 验证码按钮是否进入倒计时
      countDown: false,
      // 倒计时时间长度
      count: 60,
      // 存放延时器
      timer: null,
      dialogVisible: false,
      imgCodeError: '',
      dialogForm: {
        imgCode: '',
        captchaToken: ''
      },
      dialogRules: {
        imgCode: [
          {
            required: true,
            message: '图形验证码不能为空',
            trigger: ['blur', 'change']
          }
        ]
      },
      buttonLoading: false // 按钮加载状态
    }
  },

  methods: {
    // 显示图形验证码弹出框
    showDialog() {
      if (this.countDown) return

      this.dialogVisible = true
    },

    // 获取验证码
    // 添加防抖，防止短时间内发送多次重复的请求
    requestVerifyCode() {
      this.loading = true
      getVerifyCodeApi({
        mobile: this.mobile,
        captchaCode: this.dialogForm.imgCode,
        captchaToken: this.dialogForm.captchaToken,
        templateCode: this.templateCode
      })
        .then(res => {
          this.buttonLoading = false
          this.clearDialog()
          this.onCountDown()
          this.$message.success('验证码已经发送到您的手机，请注意查看')
          this.$emit('getSmsToken', res.data)
        })
        .catch(err => {
          this.buttonLoading = false
          this.$refs.graphicImageButton.onChangeGraphic()
          this.imgCodeError = ''
          this.imgCodeError = err.data.message
          this.$message.error(err.data.message)
        })
    },

    clearDialog() {
      this.dialogVisible = false
      this.dialogForm = {
        smsCode: '',
        captchaToken: ''
      }
      this.$refs.dialogForm.resetFields()
    },

    // 倒计时
    onCountDown() {
      this.timer && clearInterval(this.timer)
      this.count = this.maxCount

      this.countDown = true
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= this.maxCount) {
          this.count--
        } else {
          this.countDown = false
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },

    // 重置
    reset() {
      this.countDown = false
      this.count = this.maxCount
      clearInterval(this.timer)
    },

    // 弹窗确定按钮
    handleCertain() {
      this.$refs.dialogForm.validate(valid => {
        if (!valid) {
          return
        }

        this.buttonLoading = true

        this.requestVerifyCode()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.verify-code {
  height: 32px;

  .el-button {
    &.verify-code-button {
      padding: 0 16px;
      width: 100%;
    }
  }

  .dialog-content {
    display: flex;
    justify-content: center;
  }

  .form {
    ::v-deep .el-form-item__content {
      line-height: 0;
    }
  }

  .no-margin {
    margin: 0 !important;
  }
}
</style>
